import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { ValidWidths } from '@sorare/core/src/atoms/ui/ResponsiveImg';
import { CardImg } from '@sorare/core/src/components/card/CardImg';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

import Captain from '@sorare/gameplay/src/components/so5/Captain';

import { RivalsPlayerCard_footballRivalsAppearance } from './__generated__/index.graphql';

const Wrapper = styled.div`
  position: relative;
`;
const CaptainBadge = styled.aside`
  position: absolute;
  transform: translateX(-40%) translateY(-50%);
`;
const PlayerPicture = styled.div`
  width: 100%;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

type Props = {
  appearance: RivalsPlayerCard_footballRivalsAppearance;
  width?: ValidWidths;
  smallCaptain?: boolean;
};

export const RivalsPlayerCard = ({
  appearance,
  width = 80,
  smallCaptain,
}: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  const { captain, pictureUrl, player } = appearance;
  if (!pictureUrl) return null;

  if (captain) {
    return (
      <Wrapper>
        <CaptainBadge>
          <Captain
            active
            size={isTabletAndAbove && smallCaptain === false ? 4 : 2}
          />
        </CaptainBadge>
        <PlayerPicture>
          <CardImg
            src={pictureUrl}
            alt={player?.displayName || ''}
            width={width}
          />
        </PlayerPicture>
      </Wrapper>
    );
  }

  return (
    <PlayerPicture>
      <CardImg src={pictureUrl} alt={player?.displayName || ''} width={width} />
    </PlayerPicture>
  );
};

RivalsPlayerCard.fragments = {
  footballRivalsAppearance: gql`
    fragment RivalsPlayerCard_footballRivalsAppearance on FootballRivalsAppearance {
      id
      pictureUrl
      captain
      player {
        slug
        id
        displayName
      }
    }
  ` as TypedDocumentNode<RivalsPlayerCard_footballRivalsAppearance>,
};
